import React from 'react';
import { Box } from '@mui/material';
import InstructionTitle from './InstructionTitle';

/**
 * 静态复习图片组件（Letter Teams P5）
 * 全屏展示复习图片，带标题和指令
 */
function PhonicsReviewPic({ src, title, titleAudio, titleCn, instruction, instructionAudio, inlineCn = false }) {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <InstructionTitle
        title={title}
        titleAudio={titleAudio}
        titleCn={titleCn}
        instruction={instruction}
        instructionAudio={instructionAudio}
        inlineCn={inlineCn}
      />
      <Box
        component="img"
        src={src}
        alt="review"
        sx={{
          maxWidth: '100%',
          maxHeight: '65vh',
          objectFit: 'contain',
          borderRadius: 2,
          boxShadow: 3,
        }}
      />
    </Box>
  );
}

export default PhonicsReviewPic;
